import { styled } from './styled';

export const HorizontalRuler = styled('hr', {
	margin: '0 0 0 0',
	width: '100%',
	borderBottom: 'none',
	borderLeft: 'none',
	borderRight: 'none',
	borderTop: '1px solid $mono30',
});
